import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/content";

const WhatsAppFloat = () => (
  <a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with TrekPanda on WhatsApp"
    className="fixed bottom-24 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300"
    data-testid="whatsapp-float-button"
  >
    <MessageCircle className="w-7 h-7" />
  </a>
);

export default WhatsAppFloat;
